export default __webpack_public_path__ + "static/media/related-product-03.43548d8f.jpg";